import { t } from "i18next";
import { TaskBase } from "pages/project/common/taskBase.typing";

export function taskBasePriceDisplay(taskBase: TaskBase): string {
  return taskBase.price == null
    ? t("task-base.fields.priceToBeAgreed")
    : `${t("enum:intlNumber", { val: taskBase.price })} ${taskBase.currency}`;
}
